import { STXAxiosInstance } from '../Axios/STXAxiosInstance';
import { ICreateTransaction, ITransaction } from '../store';
import { CreateNewFlowResponse, SingleWalletResponse } from '../types';
import {
  IMultisigTransaction,
  transactionPayloadToMultisigTransaction,
} from '../utils/transform-multisig-transaction';

const getUserLocaleHeader = () => {
  const offset = new Date(Date.now()).getTimezoneOffset();
  const locale = navigator.language;

  return { timezoneOffset: `${offset}:${locale}` };
};

export const getTransactions = async (multisigId: string): Promise<IMultisigTransaction[]> =>
  STXAxiosInstance.get(`transactions/vault/${multisigId}`, {}).then((res) => {
    return res?.data?.data.map((i: ITransaction) => transactionPayloadToMultisigTransaction(i));
  });

export const createSafeTransaction = (
  multiSigId: string,
  rawTransactionHex: string,
  signedTransactionHex?: string,
  notesValue?: string,
  type?: 'SIGNATURE' | 'TRANSACTION'
): Promise<CreateNewFlowResponse> =>
  STXAxiosInstance.post(
    `transactions`,
    {
      multiSigId,
      rawTransactionHex,
      signedTransactionHex,
      notes: notesValue,
      type: type || 'TRANSACTION',
    } as ICreateTransaction,
    { headers: getUserLocaleHeader() }
  ).then((data) => data.data);

export const saveSignedTransaction = async (transactionId: string, signedTransactionHex: string) =>
  STXAxiosInstance.post<SingleWalletResponse>(
    `transactions/confirm`,
    {
      transactionId,
      signedTransactionHex,
    },
    { headers: getUserLocaleHeader() }
  ).then((data) => data.data.data);

export const revokeTransaction = async (transactionId: string, signedTransactionHex: string) =>
  STXAxiosInstance.post<SingleWalletResponse>(`transactions/revoke`, {
    transactionId,
    signedTransactionHex,
  }).then((data) => data.data.data);

export const executeTransaction = async (transactionId: string) =>
  STXAxiosInstance.post(
    `transactions/execute`,
    {
      transactionId,
    },
    { headers: getUserLocaleHeader() }
  ).then((data) => data.data.data);

export const getTransactionById = async (id: string) =>
  STXAxiosInstance.get<{ data: any }>('transactions/' + id).then((data) => data.data.data);
